import FormStore from 'src/core/stores/form-store';

class FormStoreMock<TItem, TNewItem> extends FormStore<TItem, TNewItem> {
  public async load(id: string) {
    return true;
  }

  public simulateLoad(item: TItem) {
    return new Promise((resolve) => {
      setTimeout(() => {
        this._state.set({
          isBusy: false,
          item: item,
        });
        resolve(item);
      }, 50);
    });
  }

  public async create(item: TNewItem) {
    return { isSuccess: true, messages: [], error: '' };
  }

  public async save(_id: string, item: TItem) {
    return { isSuccess: true, messages: [], error: '' };
  }

  public async delete(id: string, params?: any) {
    return { data: { isSuccess: true, messages: [], error: undefined }, status: 200, statusText: 'OK', headers: {}, config: {} };
  }
}

export default FormStoreMock;
